import React from 'react'
import {UiPaymentInformationWr} from "../../../components/common/UiProductElements"
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../../components/grid-container/GridContainer"
import London from "../../../../../styles/img/london-img.jpg"
import UiSingleLineInput from "../../../components/form/UiSingleLineInput"
import UiCardRadioBtn from "../../../components/form/UiCardRadioBtn"
import PayPal from "../../../../../styles/img/paypal.png"
import VisaMasterCard from "../../../../../styles/img/visa-master-xpress-card.png"
import { UiButtonPrimary, UiButtonIcon } from "../../../components/form/UiButton"


export default function PaymentInformation(props) {
    

    return (
        <>
        <UiPaymentInformationWr>
            <UiSingleRow>
                <UiCol lg="6">
                    <h3>You are buying :</h3>
                    <UiSingleRow>
                        <UiCol lg="4">
                            <img src={London} className="img-fluid sb-product-info-img " />
                        </UiCol>
                        <UiCol lg="8">
                            <h4>- London Trip (250k points,Additional 50k points)</h4>
                            <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Ut enim ad minim veniam, quis nostrud exercitation ullamco.</p>
                        </UiCol>
                    </UiSingleRow>
                </UiCol>
                <UiCol lg="4" className="offset-lg-1 sb-payment-info">
                    <h5>Payment Information</h5>
                    <div className='sb-radio-card-wr'>
                        <div className='sb-radio-card-paypal'>
                            <UiCardRadioBtn name="card" icon={PayPal} id="paypal"/>
                        </div>
                        <div className='sb-radio-card-visa-master'>
                            <UiCardRadioBtn  name="card" icon={VisaMasterCard} id="visa"/>
                        </div>
                    </div>
                    <UiSingleLineInput placeholder="Enter Name on card"/>
                    <UiSingleLineInput placeholder="Card Number"/>
                        <UiSingleRow>
                            <UiCol lg="8">
                                <UiSingleLineInput placeholder="Expiration"/>
                            </UiCol>
                            <UiCol lg="4">
                                <UiSingleLineInput placeholder="CVV"/>
                            </UiCol>
                            <UiCol lg="12">
                                <span className='sb-payment-confirm-text'>By clicking "Confirm Payment" I agree to company’s terms of service</span>
                            </UiCol>
                            <UiCol lg="12">
                                <UiButtonPrimary btnName={`Buy Now ${'250K Points + £50'}`}/>
                            </UiCol>
                           
                        </UiSingleRow>
                </UiCol>
            </UiSingleRow>
        </UiPaymentInformationWr>
            
        </>
    )
}
